import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    "& .custom-select": {
      overflowY: "auto"
    },
    bottomBar: {
      padding: "24px",
      display: "flex",
      justifyContent: "space-between"
    },
    header: {
      cursor: "pointer",
      padding: "0.8rem 1.6rem",
      background: theme.palette.gardient.medium,
      colors: "white",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: "60px",
      "& .MuiTypography-root": {
        color: "white"
      },
      "& .MuiTypography-h6": {
        lineHeight: "2.4rem",
        fontSize: "18px"
      }
    },
    searchBox: {
      "& .MuiFormControl-root": {
        height: "36px",
        fontSize: "14px !important"
      },
      padding: "24px 24px 0px 24px",
      "& .MuiSvgIcon-root": {
        fontSize: 70,
        borderRadius: 20
      }
    },
    divider: {
      padding: "0px 24px 0px 24px"
    },
    searchBoxMargin: {
      marginTop: "2rem"
    },
    arrowIcon: {
      color: "#FFFFFF"
    },
    textError: {
      color: theme.palette.error.light,
      marginTop: 5
    },
    flex: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    actionButton: {
      width: "132px",
      fontSize: "1.6rem",
      height: "40px",
      "& .MuiButton-label": {
        fontWeight: 700
      }
    },
    resetButton: {
      width: "132px",
      height: "40px",
      fontSize: "1.4rem",
      "& .MuiButton-label": {
        fontWeight: 400
      }
    },
    icon: {
      marginRight: "1.1rem"
    },
    checkbox: {
      backgroundColor: "transparent",
      boxShadow: "none !important"
    },
    radioGroup: {
      flexDirection: "row"
    },
    selectField: {
      height: "36px",
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800]
      }
    },
    disabled: {
      border: "1px solid #999999",
      backgroundColor: "#cccccc",
      color: "#666666"
    },
    required: {
      color: "#FF2600",
      "& :after": {
        content: "*"
      }
    }
  }),
  { name: "OrderFilterSection" }
);

export default useStyles;
